export function getDb () {
  return new Promise((resolve, reject) => {
    const request = window.indexedDB.open('mat-evo', 1)
    request.onerror = error => reject(error)
    request.onsuccess = response => resolve(response.target.result)
    request.onupgradeneeded = response => {
      var db = response.target.result

      db.createObjectStore('config', { keyPath: 'key' })
      db.createObjectStore('salesQueryBuilderConfig', { keyPath: 'key' })
      db.createObjectStore('clusters', { keyPath: 'cluster' })
      db.createObjectStore('dealers', { keyPath: 'idDealer' })
      db.createObjectStore('models', { keyPath: 'model' })

      const mvsObjectStore = db.createObjectStore('mvs', { keyPath: 'mvs', autoIncrement: true })
      mvsObjectStore.createIndex('brand', 'brand', { unique: false })
      mvsObjectStore.createIndex('mvs', 'mvs')
    }
  })
}

export function insert (db, tableName, value, insertLines = false) {
  return new Promise((resolve, reject) => {
    const transaction = db.transaction([tableName], 'readwrite')
    transaction.oncomplete = resolve
    transaction.onerror = reject

    if (Array.isArray(value)) {
      value.forEach(e => transaction.objectStore(tableName).add(e))
    } else {
      transaction.objectStore(tableName).add(value)
    }
  })
}

export function clear (db, tableName) {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction([tableName], 'readwrite')
    try {
      transaction.objectStore(tableName).clear()
      transaction.oncomplete = resolve
      transaction.onerror = reject
    } catch (error) {

    }
  })
}

export function readFirstLine (tableName, db) {
  return new Promise(async (resolve, reject) => {
    if (!db) {
      db = await getDb()
    }
    const transaction = db.transaction([tableName], 'readonly')
    const objectStore = transaction.objectStore(tableName)
    transaction.onerror = reject

    objectStore.openCursor().onsuccess = (event) => {
      const cursor = event.target.result
      resolve(cursor && cursor.value ? cursor.value : [])
    }
  })
}

export function dropDb () {
  return new Promise(async (resolve, reject) => {
    const request = window.indexedDB.deleteDatabase('mat-evo')
    request.onerror = error => {
      console.error(error)
      reject(error)
    }

    request.onsuccess = response => {
      resolve()
    }
  })
}

export function getAllData (tableName, db, mapFunction) {
  return new Promise(async (resolve, reject) => {
    if (!db) {
      db = await getDb()
    }
    const transaction = db.transaction([tableName], 'readonly')
    const objectStore = transaction.objectStore(tableName)
    transaction.onerror = reject

    const request = objectStore.getAll()

    request.onsuccess = event => {
      if (mapFunction) {
        resolve(mapFunction(event.target.result))
      } else {
        resolve(event.target.result)
      }
    }
    request.onerror = error => reject(error)
  })
}

export function getEmptyConfigByKey (key, db) {
  return new Promise(async (resolve, reject) => {
    if (!db) db = await getDb()

    const transaction = db.transaction(['config'])
    const objectStore = transaction.objectStore('config')
    const request = objectStore.get(key)

    request.onsuccess = event => resolve(event.target.result)
    request.onerror = error => reject(error)
  })
}

export function getMvsByMvs (mvs, db) {
  return new Promise(async (resolve, reject) => {
    if (!db) db = await getDb()

    const transaction = db.transaction(['mvs'])
    const objectStore = transaction.objectStore('mvs')
    const request = objectStore.get(mvs)

    request.onsuccess = event => resolve(event.target.result)
    request.onerror = error => reject(error)
  })
}

export function getClusterNameByCluster (cluster, db) {
  return new Promise(async (resolve, reject) => {
    if (!db) db = await getDb()
    const transaction = db.transaction(['clusters'])
    const objectStore = transaction.objectStore('clusters')
    const request = objectStore.get(cluster)

    request.onsuccess = event => resolve(event.target.result)
    request.onerror = error => reject(error)
  })
}

export function getDealerById (dealerId, db) {
  return new Promise(async (resolve, reject) => {
    if (!db) db = await getDb()

    const transaction = db.transaction(['dealers'])
    const objectStore = transaction.objectStore('dealers')
    const request = objectStore.get(dealerId)

    request.onsuccess = event => resolve(event.target.result)
    request.onerror = error => reject(error)
  })
}

export function getMvsNameByMvs (mvs, db) {
  return new Promise(async (resolve, reject) => {
    if (!db) db = await getDb()

    const request = db.transaction(['mvs'])
      .objectStore('mvs')
      .index('mvs')
      .get(mvs)

    request.onsuccess = event => resolve(event.target.result)
    request.onerror = error => reject(error)
  })
}
